/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
import type { TypeLatLng } from './TypeLatLng';
import {
    TypeLatLngFromJSON,
    TypeLatLngFromJSONTyped,
    TypeLatLngToJSON,
} from './TypeLatLng';

/**
 * 
 * @export
 * @interface V1ListCommentaryMapPinItemsRequest
 */
export interface V1ListCommentaryMapPinItemsRequest {
    /**
     * 
     * @type {TypeLatLng}
     * @memberof V1ListCommentaryMapPinItemsRequest
     */
    northWest: TypeLatLng;
    /**
     * 
     * @type {TypeLatLng}
     * @memberof V1ListCommentaryMapPinItemsRequest
     */
    southEast: TypeLatLng;
    /**
     * 
     * @type {number}
     * @memberof V1ListCommentaryMapPinItemsRequest
     */
    zoomLevel: number;
}

/**
 * Check if a given object implements the V1ListCommentaryMapPinItemsRequest interface.
 */
export function instanceOfV1ListCommentaryMapPinItemsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "northWest" in value;
    isInstance = isInstance && "southEast" in value;
    isInstance = isInstance && "zoomLevel" in value;

    return isInstance;
}

export function V1ListCommentaryMapPinItemsRequestFromJSON(json: any): V1ListCommentaryMapPinItemsRequest {
    return V1ListCommentaryMapPinItemsRequestFromJSONTyped(json, false);
}

export function V1ListCommentaryMapPinItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1ListCommentaryMapPinItemsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'northWest': TypeLatLngFromJSON(json['north_west']),
        'southEast': TypeLatLngFromJSON(json['south_east']),
        'zoomLevel': json['zoom_level'],
    };
}

export function V1ListCommentaryMapPinItemsRequestToJSON(value?: V1ListCommentaryMapPinItemsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'north_west': TypeLatLngToJSON(value.northWest),
        'south_east': TypeLatLngToJSON(value.southEast),
        'zoom_level': value.zoomLevel,
    };
}

